$(document).ready(function () {

    $(".feeds-slick-slider").slick({
        dots: false,
        arrows: true,
        infinite: true,
        autoplay: false,
        speed: 600,
        autoplaySpeed: 4000,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });




     $(".custom-icon-with-text-list").slick({
        dots: false,
        arrows: false,
        infinite: false,
        autoplay: false,
        speed: 600,
        autoplaySpeed: 4000,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1.6,
            slidesToScroll: 1,
          }
        }
      ]
    });
});